import { render, staticRenderFns } from "./PageLoaderNew.vue?vue&type=template&id=36bd223c&scoped=true"
import script from "./PageLoaderNew.vue?vue&type=script&lang=js"
export * from "./PageLoaderNew.vue?vue&type=script&lang=js"
import style0 from "./PageLoaderNew.vue?vue&type=style&index=0&id=36bd223c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd223c",
  null
  
)

export default component.exports